import { Container as MuiContainer } from '@mui/material';

/**
 * @typedef {Object} ContainerProps
 * @property {React.ReactNode} children - Container content
 * @property {string} [maxWidth] - Maximum width breakpoint (default: 'lg')
 * @property {boolean} [disableGutters] - Whether to disable gutters (default: false)
 * @property {string} [className] - Additional CSS classes
 * @property {Object} [sx] - Additional Material-UI sx props
 */

/**
 * Container component for consistent content width and centering
 *
 * A reusable container wrapper that provides consistent max-width,
 * centering, and responsive gutters for content sections.
 *
 * @param {ContainerProps} props - Component props
 * @returns {JSX.Element} Container wrapper component
 */
function Container({
  children,
  maxWidth = 'lg',
  disableGutters = false,
  className,
  sx = {},
}) {
  return (
    <MuiContainer
      maxWidth={maxWidth}
      disableGutters={disableGutters}
      className={className}
      sx={{
        px: { xs: 2, md: 3 },
        ...sx,
      }}
    >
      {children}
    </MuiContainer>
  );
}

export default Container;
